import SubmissionCard from './SubmissionCard';

export default SubmissionCard;
